import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { NEVER, Observable } from 'rxjs';

import { CustomIcon, IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { NativeBridgeService } from '@fcom/core/services/native-bridge/native-bridge.service';

@Component({
  selector: 'fin-header-boxes',
  styleUrls: ['./header-boxes.component.scss'],
  templateUrl: './header-boxes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderBoxesComponent {
  private nativeBridgeService = inject(NativeBridgeService);

  readonly CustomIcon = CustomIcon;
  readonly IconLibrary = IconLibrary;

  readonly homeLink$ = input<Observable<string>>(NEVER);
  readonly showLink = computed(() => !this.nativeBridgeService.isInsideNativeWebView);

  readonly homeGtmEvent = output<void>();
  readonly homeClick = output<Event>();

  onHomeClick(event: Event): void {
    this.homeGtmEvent.emit();
    this.homeClick.emit(event);
  }
}
